import { Box, Typography, useTheme ,Stack,Button,IconButton} from "@mui/material";
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import NiceDate from "../../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getCommands } from "../../../slices/mqtt";
import { setMessage } from "../../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import BlockIcon from '@mui/icons-material/Block';
import NiceUser from "../../../components/global/NiceUser";
import CheckIcon from '@mui/icons-material/Check';

const Commands = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const commands = useSelector((state) => state.mqtt);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);


  useEffect(() => {

    const search = {
      page,
      pageSize,
    }

    dispatch(getCommands({search}));

}, [page,pageSize]);


const processRowUpdate = React.useCallback(
  async (newRow) => {
    // Make the HTTP request to save in the backend
    //debugger
    const id = newRow.id;
    // const isBlocked = newRow.is_blocked;

    // dispatch(updateSession({id,isBlocked}));

    // return newRow;
  },
  [commands],
);

const handleProcessRowUpdateError = React.useCallback((error) => {
  dispatch(setMessage("Error editing Row"));
}, []);


  const columns = [
    { 
      field: "id", 
      headerName: "ID" ,
      flex: 1
    },
    {
      field: "sentBy",
      headerName: "Sender",
      flex: 1,
      renderCell: ({row: {sentBy}}) => {

        return (
          <NiceUser>{sentBy}</NiceUser>
        )
      }
    },
    {
      field: "signId",
      headerName: "Sign",
      flex: 1,
    },
    {
      field: "command",
      headerName: "Command",
      flex: 1,
    },
    {
      field: "value",
      headerName: "Value",
      flex: 1,
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
    },



    {
      field: "sentAt",
      headerName: "Sent",  
      flex: 1,
      renderCell: ({row: {sentAt}}) => {

        return (
          <NiceDate>{sentAt}</NiceDate>
        )
      }
    },

    {
      field: "acknowlagedAt",
      headerName: "Acknowlaged",  
      flex: 1,
      renderCell: ({row: {acknowlagedAt}}) => {

        return (
          <NiceDate>{acknowlagedAt}</NiceDate>
        )
      }
    },

    {
      field: "commandHasError",
      headerName: "Has Error",
      flex: 1,
      type: "boolean"
    },

    {
      field: "commandResponse",
      headerName: "Response",
      flex: 1,
    },


    {
      headerName: "Actions",
      field:"",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      
      renderCell: (params) => {

          const handleAck = (e) => {
            const currentRow = params.row;
            const session_id = currentRow.id;
            
            const id = currentRow.id
            const isBlocked = false;

            //dispatch(updateSession({id,isBlocked}));

          };
          

          return (
            
            <Stack key={"STACK-" + params.row.id}  direction="row" spacing={2}>

              
              <IconButton key={"LOCK-" + params.row.id} aria-label="unblock" onClick={handleAck} disabled={params.row.acknowlaged}>
                <CheckIcon />
              </IconButton>

            </Stack>
          );
      },
    },

  ];

  return (

    <Box m="20px">

      <Header title="Sign Commands" subtitle="List of comands and there status" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

          <DataGrid  experimentalFeatures={{newEditingApi: true }}
            
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            rows={commands.data.list} 
            columns={columns} 
            pageSize={pageSize}
            page={commands.data.page}
            rowsPerPageOptions={[10, 25,50,100]}
            paginationMode="server"
            rowCount={commands.data.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            
          />    

      </Box>
    </Box>
  );
};

export default Commands;
